import { render, staticRenderFns } from "./SpecificSchool.vue?vue&type=template&id=6bb8846e&scoped=true&"
import script from "./SpecificSchool.vue?vue&type=script&lang=ts&"
export * from "./SpecificSchool.vue?vue&type=script&lang=ts&"
import style0 from "./SpecificSchool.vue?vue&type=style&index=0&id=6bb8846e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8846e",
  null
  
)

export default component.exports